import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SfxTextarea from "src/components/input/SfxTextarea.vue"
import { computed, PropType } from "vue"

//region Props and Emits

const newLine = "\n"
const maxLengthTitle = 100
const maxLengthDescription = 2048

export default /*#__PURE__*/_defineComponent({
  __name: 'SfxTextareaTitled',
  props: {
  title: {
    // Add ability to define required nullable props: https://github.com/vuejs/core/issues/3948
    type: null as unknown as PropType<string | null | undefined>,
    required: true,
  },

  description: {
    type: null as unknown as PropType<string | null>,
  },

  disable: {
    type: Boolean,
    default: false,
  },
},
  emits: ["update:modelValue", "update:title", "update:description"],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit

//endregion

//region Variables

const maxLength = maxLengthTitle + maxLengthDescription

const model = computed({
  get() {
    if (!props.title) return null

    let text = props.title

    if (props.description) text += "\n" + props.description

    return text
  },

  set(text) {
    if (text) {
      text = newLineOnTitleMax(text)
    }

    emitTitleAndDescription(text)
  },
})

//endregion

//region Functions

function emitTitleAndDescription(text: string | null) {
  let title = null
  let description = null

  if (text) {
    const splitText = text.split(newLine)
    title = splitText.shift()
    description = splitText.join(newLine)
  }

  emit("update:title", title)
  emit("update:description", description)
}

function newLineOnTitleMax(text: string): string {
  const newLineInBeginning = text.indexOf(newLine) > 0 && text.indexOf(newLine) < maxLengthTitle + 1

  if (text.length <= maxLengthTitle || newLineInBeginning) {
    return text
  } else {
    const beginning = text.slice(0, maxLengthTitle)
    const ending = text.slice(maxLengthTitle)

    const lastWhiteSpace = beginning.lastIndexOf(" ")

    return lastWhiteSpace >= 0
      ? beginning.slice(0, lastWhiteSpace) + newLine + beginning.slice(lastWhiteSpace) + ending
      : beginning + newLine + ending
  }
}

//endregion

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SfxTextarea, {
    required: "",
    titled: "",
    modelValue: model.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
    modelModifiers: { trim: true },
    maxlength: maxLength,
    disable: props.disable
  }, null, 8, ["modelValue", "disable"]))
}
}

})